import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import ErrorModal from "@/components/ErrorModal";
import { migrateStatus } from "@/api";
import { handleIncompleteRegistration } from "@/lib/handleIncompleteRegistration";
import { extractApiError } from "@/lib/extractApiError";
import { navigateToBranded } from "@/lib/navigateToBranded";
import { getUtms } from "@/lib/getUtms";

const Migrate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const migrateToken = searchParams.get("migrateToken");
  const [isLoading, setIsLoading] = useState(false)
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    if (!migrateToken) {
      navigate("/register")
    } else {
      checkStatus()
    }
  }, [migrateToken, navigate]);

  const checkStatus = async () => {
    setApiError(null);
    setIsLoading(true);

    const UTMs = getUtms();

    try {
      const result = await migrateStatus(null, migrateToken);

      const token = result.data.token.uuid;
      if (token) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: "login",
            user_login_source: sessionStorage.getItem("ls") || UTMs?.utm_campaign || "direct",
          });
        }
        navigateToBranded(token);
      } else {
        setApiError({ message: "Login fehlgeschlagen. Bitte versuche es erneut.", errorCode: null });
      }
    } catch (error) {
      const errData = error.response?.data;
      if (errData?.data?.error === "error_registration_incomplete") {
        handleIncompleteRegistration(errData.data.details, navigate, true);
      } else if (errData?.data?.error === "error_unauthorized") {
        setApiError({ message: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.", errorCode: errData?.meta?.ts || null });
      } else {
        setApiError(extractApiError(errData));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-10 items-center w-full max-w-[720px] pt-[80px] pb-[48px] px-5">
      {/* Intro section */}
      <div className="flex flex-col gap-4 items-center w-full">
        <h1 className="text-black text-center text-[32px] md:text-[40px]">
          Willkommen bei Lucky Strike
        </h1>
        <p className="text-black text-center text-[18px] font-medium leading-[1.4]">
          Schön, dass du da bist.
        </p>
        <h2>Wird geladen...</h2>
      </div>
      <ErrorModal
        open={!!apiError}
        onClose={() => { setApiError(null); navigate("/reset-password") }}
        message={apiError?.message}
        errorCode={apiError?.errorCode}
      />
    </div>
  );
};

export default Migrate;
